module.exports = __webpack_public_path__ + "media/images/landing/second/photo14-73f785f782fd4773441d4cefa01ced8e.jpg";